import React, { FC } from 'react'

import PLACEHOLDER_TEXT, { PLACEHOLDER_TEXT_CUSTOM, PLACEHOLDER_TEXT_CUSTOM_TITLE } from '../consts/placeholderText'

import { InfoPlaceholder } from 'Components'
import { DateRangeString } from 'Models'

export const WrappedInfoPlaceholder = ({ title, text }: { title?: string; text: string }): JSX.Element => {
  return (
    <div className="col-12 col-lg-auto">
      <InfoPlaceholder title={title} text={text} />
    </div>
  )
}

export const InfoPlaceholderSelector: FC<{ dateRange: DateRangeString | undefined }> = ({ dateRange }) => {
  switch (dateRange) {
    case 'CUSTOM':
      return <WrappedInfoPlaceholder title={PLACEHOLDER_TEXT_CUSTOM_TITLE} text={PLACEHOLDER_TEXT_CUSTOM} />

    default:
      return <WrappedInfoPlaceholder text={PLACEHOLDER_TEXT} />
  }
}
